import { render, staticRenderFns } from "./CompetitionSelectionForm.vue?vue&type=template&id=6c24fa5b&scoped=true&"
import script from "./CompetitionSelectionForm.vue?vue&type=script&lang=js&"
export * from "./CompetitionSelectionForm.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionSelectionForm.vue?vue&type=style&index=0&id=6c24fa5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c24fa5b",
  null
  
)

export default component.exports